import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import AdminRoute from '@/components/AdminRoute';
import AdminViewRoute from '@/components/AdminViewRoute';
import CoordinatorShell from '@/components/CoordinatorShell';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Households from '@/pages/Households';
import HouseholdDetail from '@/pages/HouseholdDetail';
import MemberProfile from '@/pages/MemberProfile';
import CheckIns from '@/pages/CheckIns';
import CheckInEditor from '@/pages/CheckInEditor';
import SentCheckIns from '@/pages/SentCheckIns';
import PublicSurvey from '@/pages/PublicSurvey';
import LabTestsSettings from '@/pages/LabTestsSettings';
import VisitPrepSheet from '@/pages/VisitPrepSheet';
import HouseholdBoard from '@/pages/HouseholdBoard';
import AdminUsers from '@/pages/AdminUsers';
import AdminUserDetail from '@/pages/AdminUserDetail';
import AdminAudit from '@/pages/AdminAudit';
import AdminHouseholds from '@/pages/AdminHouseholds';
import AdminHouseholdOversight from '@/pages/AdminHouseholdOversight';
import AdminAccessLog from '@/pages/AdminAccessLog';
import AdminInvites from '@/pages/AdminInvites';
import AcceptInvite from '@/pages/AcceptInvite';
import DictionarySettings from '@/pages/DictionarySettings';
import TaggedData from '@/pages/TaggedData';
import Reminders from '@/pages/Reminders';
import RuleActivity from '@/pages/RuleActivity';
import DashboardCategory from '@/pages/DashboardCategory';
import Doctors from '@/pages/Doctors';

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes('session_id=')) return <AuthCallback />;

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/check-in/:token" element={<PublicSurvey />} />
            <Route path="/board/:token" element={<HouseholdBoard />} />
            <Route path="/prep/:appointmentId" element={<ProtectedRoute><VisitPrepSheet /></ProtectedRoute>} />

            <Route element={<ProtectedRoute><CoordinatorShell /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/:category" element={<DashboardCategory />} />
                <Route path="/households" element={<Households />} />
                <Route path="/households/:facilityId" element={<HouseholdDetail />} />
                <Route path="/members/:patientId" element={<MemberProfile />} />
                <Route path="/check-ins" element={<CheckIns />} />
                <Route path="/check-ins/:surveyId" element={<CheckInEditor />} />
                <Route path="/sent-check-ins" element={<SentCheckIns />} />
                <Route path="/doctors" element={<Doctors />} />
                <Route path="/settings/lab-tests" element={<AdminViewRoute><LabTestsSettings /></AdminViewRoute>} />
                <Route path="/reminders" element={<AdminViewRoute><Reminders /></AdminViewRoute>} />
                <Route path="/reminders/activity" element={<AdminViewRoute><RuleActivity /></AdminViewRoute>} />

                {/* Admin (also uses the same shell) */}
                <Route path="/admin" element={<AdminRoute><AdminUsers /></AdminRoute>} />
                <Route path="/admin/users/:userId" element={<AdminRoute><AdminUserDetail /></AdminRoute>} />
                <Route path="/admin/audit" element={<AdminRoute><AdminAudit /></AdminRoute>} />
                <Route path="/admin/households" element={<AdminRoute><AdminHouseholds /></AdminRoute>} />
                <Route path="/admin/households/:facilityId" element={<AdminRoute><AdminHouseholdOversight /></AdminRoute>} />
                <Route path="/admin/access-log" element={<AdminRoute><AdminAccessLog /></AdminRoute>} />
                <Route path="/admin/invites" element={<AdminRoute><AdminInvites /></AdminRoute>} />
                <Route path="/settings/dictionary" element={<AdminViewRoute><DictionarySettings /></AdminViewRoute>} />
                <Route path="/settings/tagged-data" element={<AdminViewRoute><TaggedData /></AdminViewRoute>} />
            </Route>

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
}

export default function App() {
    return <BrowserRouter><AppRouter /></BrowserRouter>;
}
